import { Module } from 'vuex'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { ModuleState, RootState } from './types'

export const module: Module<ModuleState, RootState> = {
  actions,
  getters,
  mutations,
  state: {
    availableDates: [],
    bookings: [],
    subscriptions: {
      bookings: null,
      dates: null,
    },
  },
}

export { Action } from './actions'
export { Mutation } from './mutations'
export { Booking } from './types'
export default module
